import {createDialog} from './dialog';
// @ts-ignore
let $ = window.jQuery;

export function displayInlineLayoutOptions(): string {
    let layoutSelectionBlock = `<p>${PDFGenerator.text_label_layout_selector}</p><ul class="gf-pdf-layouts-list"><li>
                <label>
                <input type="radio" class="gf-pdf-label-inline" name="pdf_layout" value="default" checked> Default
                </label>
                </li>`;
    PDFGeneratorFormSettings.pdf_layout.forEach((layout) => {
        layoutSelectionBlock += `<li>
                <label class="gf-pdf-label-inline"><input type="radio" name="pdf_layout" value="${layout.id}">${layout.name}</label> (<a href="${layout.url}" target="_blank">Preview</a>)
                </li>`
    });
    layoutSelectionBlock += '</ul>';

    return layoutSelectionBlock;
}

type ActionLayoutCallback = (layoutId: string) => void;

export function displayLayoutOptionsDialog(cb: ActionLayoutCallback, cancelCb = () => {}): void {
    const dialog = createDialog('<span class="gf-pdf-button -small -cancel gf-pdf-modal-close">close</span>', `<form>${displayInlineLayoutOptions()}
        <div class="gf-pdf-modal-footer"><button class="gf-pdf-button continue-layout-selected -centered" type="submit">${PDFGenerator.text_continue}</button></div></div></form>`);
    dialog[0].showModal();
    dialog.on('click', '.continue-layout-selected', function (e) {
        e.preventDefault();
        const layoutId = $('input[name="pdf_layout"]:checked').val() as string;
        cb(layoutId);
        dialog.remove();
    });
}